<template>
  <div class="w-full max-w-md mx-auto">
    <form class="w-full" @submit.prevent="submit" v-if="!success">
      <p
        class="text-center text-grey-7 mb-2"
      >You may request an email to reset your password. Please enter your account's email to continue.</p>
      <div class="w-full mb-2 px-2">
        <nx-input
          v-model="email"
          :errors="form.errors"
          placeholder="zealot@auir.com"
          id="email"
          type="email"
          label="Email"
          maxlength="255"
          :focus="true"
        />
      </div>

      <div class="w-full text-center">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Request Email' }}</nx-button>
      </div>
    </form>

    <div class="w-full" v-else>
      <p class="text-center mb-2">Please check your email to continue.</p>
    </div>
  </div>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "ForgotPasswordForm",
  data() {
    return {
      form: new Form(),
      email: "",
      success: false,
      loading: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.$api.auth
        .forgotPassword({ email: this.email })
        .then(() => {
          this.success = true
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else{
            this.$error.generic()
          }
        })
      this.loading = false
    }
  }
}
</script>

